import { PayGroup } from '../../../shared/models/pay-group.model';
import { PayrollCycleType, PayrollTypeInfo } from '../../../services/payroll-types.service';
import {ProductCode} from '../../../shared/enums/smarthub-enums';
import { Moment } from 'moment';
import * as moment from 'moment';


export class DashboardFilters {
  private _payDate: Moment;
  payrollType: PayrollCycleType;
  payGroups: PayGroup[];
  get products(): number[] {
    return [ProductCode.EmployeePay]; // Employee Pay; currently cannot be changed.
  }

  constructor(payDate: Moment, payType: PayrollCycleType, payGroups: PayGroup[]) {
    this._payDate = payDate;
    this.payrollType = payType;
    this.payGroups = payGroups;
  }

  get payDate(): Moment {
    return this._payDate;
  }

  /**
   * ULTI-406602: If the datepicker has an invalid date, it sends it in as a string instead of a moment.
   * @param value
   */
  set payDate(value: Moment) {
    if (value && typeof value !== 'string') {
      this._payDate = value.clone();
    }
  }

  /**
   * Returns a true/false value indicating if the filter values are different.
   * Used in a distinctUntilChanged() pipe
   * @param a
   * @param b
   */
  static compareFilters(a: DashboardFilters, b: DashboardFilters): boolean {
    if (!!a !== !!b) {
      return false;
    }
    if (!a) {
      return true;
    }

    if (!!a.payDate !== !!b.payDate
      || moment.isMoment(a.payDate) !== moment.isMoment(b.payDate)
      || !!a.payGroups !== !!b.payGroups) {

      return false;
    }

    if (a.payDate) {
      if (moment.isMoment(a.payDate)) {
        if (!a.payDate.isSame(b.payDate)) {
          return false;
        }
      } else if (a.payDate !== b.payDate) {
        return false;
      }
    }

    if (a.payrollType !== b.payrollType) {
      return false;
    }

    if (a.payGroups) {
      if (a.payGroups.length !== b.payGroups.length) {
        return false;
      }
      for (let i = 0; i < a.payGroups.length; i++) {
        if (a.payGroups[i].code !== b.payGroups[i].code) {
          return false;
        }
      }
    }

    return true;
  }

  public static _compareArray(a: any[], b: any[]): boolean {
    if (!a) {
      return !b || !b.length;
    }
    if (!b) {
      return !a.length;
    }

    if (a.length !== b.length) {
      return false;
    }

    const hash = {};
    for (const item of a) {
      const value = hash[item];
      if (value) {
        hash[item] = value + 1;
      } else {
        hash[item] = 1;
      }
    }

    for (const item of b) {
      if (hash[item]) {
        hash[item]--;
      } else {
        return false;
      }
    }

    return true;
  }

  getPaySequences(): number[] {
    return new PayrollTypeInfo(this.payrollType).paySequences;
  }
}
